import 'assets_sp/css//style.css'
import $ from 'jquery'

const topBtn = $('#pagetop')
const searchBtn = $('#searchButton')
const headerElm = $('#header')
const pagetopWrp = $('.pagetop__wrp')
let showFlg = false

topBtn.click(() => {
  $('body,html').animate({scrollTop: 0}, 500)
  return false
})

searchBtn.click(() => {
  headerElm.toggleClass('-searching')
})

$(window).scroll(function () {
  // console.log($(window).height())
  // console.log($(this).scrollTop())
  // console.log(pagetopWrp.offset().top)
  if ($(this).scrollTop() > 100) {
    if (!showFlg) {
      topBtn.addClass('-fixed')
      topBtn.fadeIn()
      showFlg = true
    }
    if (($(this).scrollTop() + $(window).height()) > pagetopWrp.offset().top) {
      topBtn.removeClass('-fixed')
    } else {
      topBtn.addClass('-fixed')
    }
  } else {
    if (showFlg) {
      topBtn.fadeOut()
      showFlg = false
    }
  }
})



// WEBPACK FOOTER //
// ./src/assets/sp/js/organizations/index.js